'use strict';

angular.module('amexReconciliationApp')
  .component('repaginationDisplay', {
    templateUrl: 'scripts/views/components/repagination-display.html',
    controller: function (TransactionPaginationService,
                          TransactionSortModel) {
      
      var self = this;

      self.$onInit = function() {
        self.pageSize = TransactionPaginationService.pageSize().toString();
        self.pageSizeValidValues = ['50','100','500','1000'];
      };

      self.setPageSize = function () {
        TransactionPaginationService.pageSize(parseInt(self.pageSize));
        TransactionPaginationService.repaginate(TransactionSortModel.transactions());
        TransactionPaginationService.updatePreferences(self.pageSize);
      };

    }
  });
      
      
      
      
      
      
    


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/repaginationDisplay.js
// module id = 477
// module chunks = 0